/**
 * Beta Wrapper Component
 *
 * Wraps the entire application and checks if user is a beta user with expired access.
 * Shows the BetaExpiredBlocker overlay if beta has expired.
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useBetaStatus } from '@/hooks/useBetaStatus';
import { BetaExpiredBlocker } from './BetaExpiredBlocker';

interface BetaWrapperProps {
  children: React.ReactNode;
}

export const BetaWrapper: React.FC<BetaWrapperProps> = ({ children }) => {
  const { isBetaUser, betaExpired, betaEndDate, loading } = useBetaStatus();
  const location = useLocation();

  // Don't block on public pages, auth pages, or onboarding
  const isPublicPage =
    location.pathname === '/' ||
    location.pathname.startsWith('/auth') ||
    location.pathname.startsWith('/onboarding') ||
    location.pathname.startsWith('/help') ||
    location.pathname.startsWith('/privacy') ||
    location.pathname.startsWith('/terms') ||
    location.pathname.startsWith('/cookies') ||
    location.pathname.startsWith('/contact') ||
    location.pathname.startsWith('/pricing') ||
    location.pathname.startsWith('/tarifs') ||
    location.pathname.startsWith('/product-details') ||
    location.pathname.startsWith('/simulateurs') ||
    location.pathname.startsWith('/plateforme') ||
    location.pathname.startsWith('/guides') ||
    location.pathname.startsWith('/entreprises') ||
    location.pathname.startsWith('/consultants') ||
    location.pathname.startsWith('/particuliers') ||
    location.pathname.startsWith('/regions');

  // Show blocker if:
  // 1. Not loading
  // 2. Is beta user
  // 3. Beta has expired
  // 4. Not on a public page
  if (!loading && isBetaUser && betaExpired && !isPublicPage && betaEndDate) {
    return <BetaExpiredBlocker betaEndDate={betaEndDate} />;
  }

  return <>{children}</>;
};
